import React from "react";
import _, { isEmpty } from "lodash";
import { Button, Col } from "react-bootstrap";
import { connect } from "react-redux";
import {
  formValueSelector,
  getFormInitialValues,
  change,
  Field,
  Fields
} from "redux-form";
import PropTypes from "prop-types";
import { Map, fromJS } from "immutable";
import removeKey, { removeKeys } from "LIB/removeKey";
import { addDays } from "LIB/time";
import validate from "MODULES/RepairOrders/components/Detail/LineItems/validate";
import { Authorized } from "MODULES/shared/components";
import {
  ACCOUNTING,
  SUBROLE,
  USER,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import {
  form,
  FormInput,
  FormRow,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import {
  searchInventories as queryInventories,
  searchPartsByStatus,
  searchParts
} from "MODULES/parts/actions/actions";
import {
  ACTIONS_REQUESTED,
  BENCH_TEST,
  EXPECTED_COMPONENT,
  OVERHAUL,
  REPAIR,
  REPAIR_AWAITING_EVALUATION,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED,
  TEARDOWN,
  SHOP_ASSIST,
  AWAITING_TO_SHIP,
  ACTION_REQUESTED,
  ORIGINAL_EVALUATION,
  APPROVAL_STATUS,
  EVAL_DUE_DATE,
  REPAIR_AND_HOLD,
  ESTIMATED_LEAD_TIME,
  NO_WORK_PERFORMED,
  AFTER_INTERNAL_OUTRIGHT,
  ASKING_INTERNAL_OUTRIGHT,
  ASKING_EXPECTED_COMPONENTS,
  REMOVE_EXPECTED_COMPONENTS,
  WARRANTY_CONSIDERATION
} from "MODULES/RepairOrders/constants";
import InvoiceSection from "MODULES/Orders/shared/InvoiceSection";
import { properCase } from "LIB/formatters/text";
import {
  CAAC,
  EASA,
  FAA,
  INTERNAL_OUTRIGHT,
  OTHER,
  OTHER_TAG_TYPE,
  TCCA,
  UK_CAA
} from "MODULES/inventories/constants";
import TagTypes from "MODULES/inventories/components/EditInventory/TagTypes";
import { TIER_TYPE } from "MODULES/parts/constants";
import { COMPANY, LINE_ITEMS, RECEIVED } from "APP_ROOT/constants";
import {
  EXPECTED_DATE,
  LABOR_COST,
  PART_COST
} from "MODULES/SalesOrders/constants";
import { OUTGOING_AWB_NUMBER } from "MODULES/Shipping/constants";
import {
  getDisplayShipmentVal,
  getOutrightVal
} from "MODULES/RepairOrders/components/Detail/LineItems/helpers";
import RequiredComponents from "MODULES/RepairOrders/components/Detail/LineItems/FormSections/RequiredComponents/RequiredComponents";
import {
  ExchangeSection,
  ExpectedComponentSection,
  NotesSection,
  ActionRequestedSection,
  CostSection,
  PartDetailsSection
} from "./FormSections";
import Summary from "./Summary";
import { CapAmountWarning } from "./Warnings";
import Warning from "../../../../shared/components/Warning/Warning";

const FORM_NAME = "repairOrderLineItem";

function AskIfAfterInternalOutright(props) {
  const selected = props.getFieldValue(AFTER_INTERNAL_OUTRIGHT);

  return [
    <Warning>
      Please confirm if the Parts & Labor charges associated to this record
      should be applied as new cost (After Internal Outright) or as old cost
      (Before Internal Outright).
    </Warning>,
    <div className="btn-group" style={{ marginLeft: 10 }}>
      <button
        className={`btn btn-default ${selected && "active"}`}
        type="button"
        onClick={() => {
          props.change(AFTER_INTERNAL_OUTRIGHT, true);
          props.setAskedInternalOutright(true);
        }}
      >
        After Internal Outright
      </button>
      <button
        className={`btn btn-default ${!selected && "active"}`}
        type="button"
        onClick={() => props.setAskedInternalOutright(false)}
      >
        Before Internal Outright
      </button>
    </div>
  ];
}

function AskIfRemovingExpectedComponents(props) {
  const selected = props.getFieldValue(REMOVE_EXPECTED_COMPONENTS);

  return [
    <Warning>Would you like to keep or cancel all subcomponents?</Warning>,
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div className="btn-group" style={{ marginLeft: 10 }}>
        <button
          className={`btn btn-primary ${!selected && "active"}`}
          type="button"
          onClick={() => {
            props.change(REMOVE_EXPECTED_COMPONENTS, false);
          }}
        >
          Keep
        </button>
        <button
          className={`btn btn-primary ${selected && "active"}`}
          type="button"
          onClick={() => props.change(REMOVE_EXPECTED_COMPONENTS, true)}
        >
          Remove
        </button>
      </div>
    </div>
  ];
}

export class Form extends React.Component {
  state = {
    selectedInventory: {}
  };

  componentWillMount() {
    const { lineItem } = this.props;
    if (lineItem) {
      this.setState({ selectedInventory: lineItem });
      if (lineItem.estimated_lead_time && !lineItem.expected_date) {
        const addLeadDate = addDays(new Date(), lineItem.estimated_lead_time);
        this.props.change(
          EXPECTED_DATE,
          new Date(addLeadDate).toISOString().split("T")[0]
        );
      }
    }
  }

  notifyForm = item => {
    this.setState({ selectedInventory: item });
  };

  handleLeadTimeChange = (e = {}) => {
    const days = e.target && e.target.value;
    if (days) {
      const leadDate = addDays(new Date(), days);
      this.props.change(
        "expected_date",
        new Date(leadDate).toISOString().split("T")[0]
      );
    }
  };

  handleActionChange = action => {
    if (action === EXPECTED_COMPONENT) {
      this.props.change(APPROVAL_STATUS, REPAIR_AWAITING_EVALUATION);
      [FAA, EASA, CAAC, TCCA, OTHER].forEach(f =>
        this.props.change(
          `${f}`,
          this.props.repairOrder.get("company").get(`${f}_approved`) || false
        )
      );
    }
  };

  render() {
    const {
      lineItem,
      modTo,
      part,
      queryParts,
      queryPartsByStatus,
      shopAssistRepairOrder,
      setFieldValue,
      getFieldValue,
      getInitialFieldValue,
      searchInventories,
      editing = false,
      readOnly = false,
      repairOrder,
      shouldAskInternalOutright,
      subrole
    } = this.props;
    const { selectedInventory } = this.state;
    const requestedAction = getFieldValue(ACTION_REQUESTED);
    const hasRepairItem = repairOrder
      .get(LINE_ITEMS)
      .some(i =>
        [REPAIR, BENCH_TEST, OVERHAUL].includes(i.get(ACTION_REQUESTED))
      );
    const hasTeardown = repairOrder
      .get(LINE_ITEMS)
      .some(i => i.get(ACTION_REQUESTED) === TEARDOWN);

    const hasExpectedComponent = repairOrder
      .get(LINE_ITEMS)
      .some(i => i.get(ACTION_REQUESTED) === EXPECTED_COMPONENT);

    const hasGoneOutright = getOutrightVal(getFieldValue);

    const exchange =
      (selectedInventory.inventory &&
        selectedInventory.inventory.exchange_eval_in_progress) ||
      hasGoneOutright;

    const outrightValue = getFieldValue(
      "inventory.most_recent_sales_order.outright_value"
    );

    const originalEvalGreaterThanOutrightVal =
      getFieldValue(ORIGINAL_EVALUATION) &&
      outrightValue &&
      parseFloat(getFieldValue(ORIGINAL_EVALUATION)) >
        parseFloat(outrightValue);

    let filteredActions = ACTIONS_REQUESTED;
    if (!editing) {
      filteredActions = hasTeardown
        ? removeKey(filteredActions, TEARDOWN)
        : removeKey(filteredActions, EXPECTED_COMPONENT);
      filteredActions = hasRepairItem
        ? filteredActions
        : removeKey(filteredActions, SHOP_ASSIST);
    } else if (getInitialFieldValue(ACTION_REQUESTED) === TEARDOWN) {
      filteredActions = removeKeys(filteredActions, [
        EXPECTED_COMPONENT,
        WARRANTY_CONSIDERATION,
        SHOP_ASSIST
      ]);
    }

    const originalEval = getFieldValue(ORIGINAL_EVALUATION);
    const approvalStatus = getFieldValue(APPROVAL_STATUS);
    const warehouseDirector = subrole === WAREHOUSE_LOGISTICS_DIRECTOR;
    const isConsignment = _.get(lineItem, "inventory.consignment_type");
    const canEditOutgoingAwb =
      approvalStatus !== AWAITING_TO_SHIP || isConsignment;

    const forceAskIfInternalOutright =
      !getFieldValue("asking_internal_outright") &&
      !getFieldValue(RECEIVED) &&
      shouldAskInternalOutright &&
      approvalStatus === REPAIR_EVALUATION_APPROVED &&
      [LABOR_COST, PART_COST].some(
        f => !isEmpty(getFieldValue(f)) && isEmpty(getInitialFieldValue(f))
      ) &&
      getInitialFieldValue(INTERNAL_OUTRIGHT) &&
      !getFieldValue(INTERNAL_OUTRIGHT);

    const forceAskIfCancellingTeardown =
      !getFieldValue(RECEIVED) &&
      hasExpectedComponent &&
      getInitialFieldValue(ACTION_REQUESTED) === TEARDOWN &&
      getFieldValue(ACTION_REQUESTED) !== TEARDOWN;

    const askingInternalOutright = getFieldValue(ASKING_INTERNAL_OUTRIGHT);
    const askingExpectedComponents = getFieldValue(ASKING_EXPECTED_COMPONENTS);
    const setAskedInternalOutright = val =>
      setFieldValue("asked_internal_outright", val);

    const parseValue = value => (value === "" ? 0 : value);

    const formatValue = value => (value === 0 ? "" : value);

    const parseDateValue = value => (value === "" ? "" : value);

    const formatDateValue = value => (value === "" ? "" : value);

    if (askingInternalOutright) {
      return (
        <AppForm {...this.props} editable={!readOnly}>
          <AppForm.Body>
            <AskIfAfterInternalOutright
              getFieldValue={getFieldValue}
              change={setFieldValue}
              setAskedInternalOutright={setAskedInternalOutright}
            />
          </AppForm.Body>
        </AppForm>
      );
    }

    if (askingExpectedComponents) {
      return (
        <AppForm {...this.props} editable={!readOnly}>
          <AppForm.Body>
            <AskIfRemovingExpectedComponents
              getFieldValue={getFieldValue}
              change={setFieldValue}
            />
          </AppForm.Body>
        </AppForm>
      );
    }

    return (
      <AppForm {...this.props} editable={!readOnly}>
        {[
          <AppForm.Body>
            <CapAmountWarning originalEval={originalEval} lineItem={lineItem} />
            <div className="nav nav-tabs">
              <h4>Action Requested</h4>
            </div>
            <FormRow>
              <Col md={8}>
                <div className="tab-content">
                  <div role="tabpanel" className="tab-pane active">
                    <ActionRequestedSection
                      onActionChange={(ev, action) =>
                        this.handleActionChange(action)}
                      change={this.props.change}
                      exchange={exchange}
                      editing={editing}
                      formName="repairOrderLineItem"
                      outrightValue={outrightValue}
                      originalEvalGreaterThanOutrightVal={
                        originalEvalGreaterThanOutrightVal
                      }
                      shopAssistRepairOrder={shopAssistRepairOrder}
                      setField={setFieldValue}
                      getField={getFieldValue}
                      getInitialFieldValue={getInitialFieldValue}
                      disabled={readOnly || warehouseDirector}
                      repairOrder={repairOrder}
                      actions={filteredActions}
                      tierType={_.get(part, TIER_TYPE)}
                    />
                    <FormRow>
                      <Col md={12}>
                        <Fields
                          names={[
                            FAA,
                            EASA,
                            UK_CAA,
                            CAAC,
                            TCCA,
                            OTHER,
                            OTHER_TAG_TYPE
                          ]}
                          component={TagTypes}
                          formName={FORM_NAME}
                          required={
                            ![
                              REPAIR_EVALUATION_REJECTED,
                              NO_WORK_PERFORMED
                            ].includes(approvalStatus)
                          }
                        />
                      </Col>
                    </FormRow>
                    {requestedAction && (
                      <PartDetailsSection
                        modTo={modTo}
                        part={part}
                        queryParts={queryParts}
                        queryPartsByStatus={queryPartsByStatus}
                        searchInventories={searchInventories}
                        setField={setFieldValue}
                        getField={getFieldValue}
                        notifyForm={this.notifyForm}
                        requestedAction={requestedAction}
                        editing={editing}
                        disabled={readOnly || warehouseDirector}
                      />
                    )}
                    <ExpectedComponentSection
                      formName={FORM_NAME}
                      disabled={readOnly || warehouseDirector}
                      requestedAction={requestedAction}
                    />
                    {requestedAction && (
                      <CostSection
                        lineItem={Map(selectedInventory)}
                        disabled={warehouseDirector}
                        getField={getFieldValue}
                        requestedAction={requestedAction}
                        setFieldValue={setFieldValue}
                      />
                    )}
                    {requestedAction &&
                      requestedAction !== SHOP_ASSIST && (
                        <React.Fragment>
                          <FormRow>
                            <Col md={4}>
                              <div className="form-group">
                                <Field
                                  name="work_order_number"
                                  component={FormInput}
                                  label="Work Order Number"
                                  disabled={readOnly || warehouseDirector}
                                />
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="form-group">
                                <Field
                                  name={ESTIMATED_LEAD_TIME}
                                  component={FormInput}
                                  label="Est. Lead Time"
                                  parse={parseValue}
                                  format={formatValue}
                                  disabled={
                                    readOnly ||
                                    warehouseDirector ||
                                    getFieldValue(REPAIR_AND_HOLD)
                                  }
                                  onChange={this.handleLeadTimeChange}
                                />
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="form-group">
                                <Field
                                  name={EXPECTED_DATE}
                                  component={FormInput}
                                  label="Expected Date"
                                  parse={parseDateValue}
                                  format={formatDateValue}
                                  disabled={
                                    readOnly ||
                                    warehouseDirector ||
                                    getFieldValue(REPAIR_AND_HOLD)
                                  }
                                  type="date"
                                />
                              </div>
                            </Col>
                          </FormRow>
                          <FormRow>
                            <Col md={4}>
                              <Field
                                name={EVAL_DUE_DATE}
                                component={FormInput}
                                label={properCase(EVAL_DUE_DATE)}
                                disabled={readOnly || warehouseDirector}
                                type="date"
                              />
                            </Col>
                            {canEditOutgoingAwb && (
                              <Col md={4}>
                                <Field
                                  name={OUTGOING_AWB_NUMBER}
                                  component={FormInput}
                                  label="Outgoing AWB Number"
                                  disabled={
                                    approvalStatus !==
                                      REPAIR_EVALUATION_APPROVED &&
                                    approvalStatus !==
                                      REPAIR_EVALUATION_REJECTED &&
                                    !isConsignment
                                  }
                                />
                              </Col>
                            )}
                            {requestedAction !== EXPECTED_COMPONENT && (
                              <Col md={3}>
                                <Field
                                  name="date_out"
                                  label="Ship Date"
                                  component={FormInput}
                                  type="date"
                                  disabled
                                />
                              </Col>
                            )}
                          </FormRow>
                        </React.Fragment>
                      )}
                    {requestedAction &&
                      (exchange || readOnly) &&
                      requestedAction !== EXPECTED_COMPONENT &&
                      requestedAction !== TEARDOWN && (
                        <ExchangeSection
                          getField={getFieldValue}
                          getInitialFieldValue={getInitialFieldValue}
                          originalEvalGreaterThanOutrightVal={
                            originalEvalGreaterThanOutrightVal
                          }
                          requestedAction={requestedAction}
                          disabled={warehouseDirector}
                        />
                      )}
                    <Authorized roles={[ACCOUNTING]}>
                      <InvoiceSection />
                    </Authorized>
                    <RequiredComponents
                      company={repairOrder.get(COMPANY).toJS()}
                      lineItem={lineItem}
                      getFieldValue={getFieldValue}
                    />
                    {requestedAction && <NotesSection disabled={readOnly} />}
                  </div>
                </div>
              </Col>
              {editing && (
                <Col md={4}>
                  <Summary
                    getField={getFieldValue}
                    lineItem={fromJS(selectedInventory)}
                    repairOrder={repairOrder}
                  />
                </Col>
              )}
            </FormRow>
          </AppForm.Body>,
          forceAskIfInternalOutright && (
            <AppForm.Footer>
              <Button onClick={this.props.close}>Cancel</Button>
              <Button
                type="button"
                bsStyle="primary"
                onClick={() => setFieldValue(ASKING_INTERNAL_OUTRIGHT, true)}
              >
                Save
              </Button>
            </AppForm.Footer>
          ),
          forceAskIfCancellingTeardown && (
            <AppForm.Footer>
              <Button onClick={this.props.close}>Cancel</Button>
              <Button
                type="button"
                bsStyle="primary"
                onClick={() => setFieldValue(ASKING_EXPECTED_COMPONENTS, true)}
              >
                Save
              </Button>
            </AppForm.Footer>
          )
        ].filter(f => f)}
      </AppForm>
    );
  }
}

Form.propTypes = {
  change: PropTypes.func.isRequired,
  getFieldValue: PropTypes.func.isRequired,
  getInitialFieldValue: PropTypes.func.isRequired,
  queryParts: PropTypes.func.isRequired,
  queryPartsByStatus: PropTypes.func.isRequired,
  searchInventories: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  modTo: PropTypes.bool.isRequired,
  editing: PropTypes.bool,
  readOnly: PropTypes.bool,
  part: PropTypes.shape({}),
  shopAssistRepairOrder: PropTypes.shape({}),
  lineItem: PropTypes.shape({
    final_evaluation_approved_on: PropTypes.string
  }),
  repairOrder: PropTypes.instanceOf(Map)
};

export default connect(
  state => ({
    subrole: state.session.getIn([USER, SUBROLE]),
    getFieldValue: field => formValueSelector(FORM_NAME)(state, field),
    getInitialFieldValue: field =>
      _.get(getFormInitialValues(FORM_NAME)(state), field),
    displayShipmentUpdateReminder: getDisplayShipmentVal(FORM_NAME, state)
  }),
  dispatch => ({
    queryParts: filter => dispatch(searchParts(filter)),
    queryPartsByStatus: filter => dispatch(searchPartsByStatus(filter)),
    searchInventories: (partId, filters) =>
      dispatch(queryInventories(partId, filters)),
    setFieldValue: (field, val) => dispatch(change(FORM_NAME, field, val))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/Form.jsx